import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../../components/table/ResultTable";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import CheckCSName from "../CheckCSName";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import ResultText from "../ResultText";

export default function SV3({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

function Description({row, settings, globalVariables}) {
    switch (row.error_id) {
        case MessageCodes.Internal.SV03.error_id: {
            return (
                <ResultText>
                    The top of bank elevations is not consistent with the survey data at the following {row?.data?.length} cross sections.
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20)}}>Left</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20)}}>Right</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {

                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>
                                                <CheckCSName csName={r?.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>{r?.left_elev_survey?.toFixed(2)}</ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                {ResultCellHighlight(r?.left_elev_survey?.toFixed(2), r?.left_elev?.toFixed(2))}
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>{r?.right_elev_survey?.toFixed(2)}</ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                {ResultCellHighlight(r?.right_elev_survey?.toFixed(2), r?.right_elev?.toFixed(2))}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </ResultText>
            )
        }
    }
}